
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";

export const Contact = () => {
  const { colors, theme } = useTheme();
  
  return (
    <div 
      className="backdrop-blur-md border rounded-lg p-6 md:p-8 transition-colors duration-300 shadow-2xl"
      style={{ 
        backgroundColor: theme === 'light' ? `${colors.card}95` : `${colors.card}95`,
        borderColor: `${colors.primary}40`,
        boxShadow: `0 12px 40px ${colors.primary}15, 0 8px 25px ${colors.primary}10, inset 0 1px 0 ${colors.primary}20`,
        backdropFilter: 'blur(20px) saturate(1.8)',
      }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-4xl font-bold text-center mb-8"
        style={{
          background: colors.gradient,
          backgroundSize: "200% auto",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textShadow: `0 0 20px ${colors.primary}30`
        }}
      >
        Get In{" "}
        <span 
          className="bg-clip-text text-transparent"
          style={{ background: colors.gradient, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}
        >
          Touch
        </span>
      </motion.h2>
      <div className="space-y-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center p-4 rounded-lg border transition-colors duration-300 backdrop-blur-sm"
          style={{ 
            backgroundColor: theme === 'light' ? `${colors.card}90` : `${colors.card}90`,
            borderColor: `${colors.primary}30`,
            boxShadow: `0 4px 16px ${colors.primary}10`
          }}
        >
          <h3 className="text-lg font-semibold mb-2" style={{ color: colors.foreground }}>Call us</h3>
          <p className="text-lg font-medium" style={{ color: colors.primary }}>+91 98400 13251</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center p-4 rounded-lg border transition-colors duration-300 backdrop-blur-sm"
          style={{ 
            backgroundColor: theme === 'light' ? `${colors.card}90` : `${colors.card}90`,
            borderColor: `${colors.primary}30`,
            boxShadow: `0 4px 16px ${colors.primary}10`
          }}
        >
          <h3 className="text-lg font-semibold mb-2" style={{ color: colors.foreground }}>Write to Us</h3>
          <p className="text-lg font-medium" style={{ color: colors.primary }}>info@agapeentertainment.in</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center p-4 rounded-lg border transition-colors duration-300 backdrop-blur-sm"
          style={{ 
            backgroundColor: theme === 'light' ? `${colors.card}90` : `${colors.card}90`,
            borderColor: `${colors.primary}30`,
            boxShadow: `0 4px 16px ${colors.primary}10`
          }}
        >
          <h3 className="text-lg font-semibold mb-2" style={{ color: colors.foreground }}>Office Hours</h3>
          <p className="text-lg font-medium" style={{ color: colors.primary }}>Mon-Sat 9:00 - 7:00</p>
        </motion.div>
      </div>
    </div>
  );
};
